exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".text-root-1y8 {\n    display: flex;\n    flex-direction: column;\n    word-wrap: break-word;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "text-root-1y8"
};